let isLoaded = false;

function notify() {
    const response = new CustomEvent('youtube-js-loaded');
    document.dispatchEvent(response);
}

window.onYouTubeIframeAPIReady = () => {
    isLoaded = true;
    notify();
}

window.loadYoutubeIframeAPI = () => {
    // try to find the script tag and create it if it doesn't exist
    let script = document.getElementById('youtube-js') as HTMLScriptElement | null;
    if (!script) {
        script = document.createElement('script') as HTMLScriptElement;
        script.id = 'youtube-js';
        script.src = 'https://www.youtube.com/iframe_api';
        document.body.appendChild(script);
    }

    // notify if already loaded
    if (isLoaded) {
        notify();
    }
}

